<script>
    import { createEventDispatcher } from 'svelte';
    import { onMount } from 'svelte';
  
    export let isLoading = false;
    export let placeholder = 'Enter clinical notes here...';
    export let selectedCodeType = 'ICD-10';
    export let clinicalNotes = '';
    export let files = [];
    export let isDemoMode = false;
    export let demoText = '';
    export let hasRanOnce = false;
    const dispatch = createEventDispatcher();
  
    function handleKeyDown(e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
        }
    }
  
    function sendMessage() {
        if (!clinicalNotes.trim() && files.length === 0 && !isDemoMode) return;
        //disable the demo button after sending the message
        if (isDemoMode && hasRanOnce) {
            return;
        }
        dispatch('send', { text: clinicalNotes, attachments: files });
        hasRanOnce = true;
    }

    function handleFileUpload(event) {
        const uploadedFiles = [...event.target.files];
        files = [...files, ...uploadedFiles];
    }

    function handleDrop(event) {
        event.preventDefault();
        const droppedFiles = [...event.dataTransfer.files];
        files = [...files, ...droppedFiles];
    }

    function handlePaste(event) {
        const clipboardItems = [...event.clipboardData.items];
        clipboardItems.forEach(item => {
            if (item.kind === 'file') {
                files = [...files, item.getAsFile()];
            }
        });
    }

    function handleStop() {
        dispatch('stop'); // NEW
    }
</script>

<div class="d-flex flex-column p-2 border border-dark mx-2 mx-lg-0 {isDemoMode ? 'bg-white' : 'bg-light'}" style="background-color: rgb(243 244 246); box-shadow: 0px 0px 0px .5px #dce0e9; border-radius: 24px;"  on:drop={handleDrop} on:paste={handlePaste}>
    <div>
        {#if isDemoMode}
            <textarea
                class="form-control"
                style="resize: none; background-color: transparent; border: none; box-shadow: none; caret-color: rgb(64, 64, 64)!important; font-size: 1rem; color: rgb(64, 64, 64) !important;"
                rows="4"
                disabled
            >{demoText}</textarea>
        {:else}
        <textarea
            class="form-control"
            style="resize: none; background-color: transparent; border: none; box-shadow: none; caret-color: rgb(64, 64, 64)!important; font-size: 1rem; color: rgb(64, 64, 64) !important;"
            rows="4"
            placeholder={placeholder}
            bind:value={clinicalNotes}
            on:keydown={handleKeyDown}
            
        ></textarea>
        {/if}
    </div>
    <div class="d-flex flex-wrap mt-2">
        {#each files as file, i}
            <div class="file-preview p-2 m-1 d-flex align-items-center" style="background-color: white; border-radius: 8px; box-shadow: 0px 0px 4px rgba(0,0,0,0.1);">
                <span>{file.name}</span>
                <button type="button" class="btn-close ms-2" on:click={() => files = files.slice(0, i).concat(files.slice(i + 1))}></button>
            </div>
        {/each}
    </div>
    <div class="d-flex align-items-center justify-content-between mt-2">
        <select bind:value={selectedCodeType} class="form-select rounded-5" aria-label="Select a coding system" style="width: auto!important; {isDemoMode ? 'cursor:not-allowed' : ''}" disabled={isDemoMode}>
            <option value="ICD-10-CM" selected>ICD-10-CM</option>
            <option value="ICD-10-PCS">ICD-10-PCS</option>
            <option value="CPT">CPT</option>
            <option value="HCPCS">HCPCS</option>
            <option value="DRG">DRG</option>
            <option value="NDC">NDC</option>
            <option value="CDT">CDT</option>
            <option value="SNOMED CT">SNOMED CT</option>
            <option value="LOINC">LOINC</option>
        </select>            
        <div class="d-flex align-items-center">
            <input type="file" id="file-upload" multiple class="d-none" on:change={handleFileUpload} disabled={isDemoMode} style="{isDemoMode ? 'cursor:not-allowed;' : ''}"/>
            <label for="file-upload" class="ds-icon mx-2" style="cursor: {isDemoMode ? 'not-allowed' : 'pointer'};">
                <svg style="width: 23px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20" fill="none">
                    <path d="M7 20c-1.856-.002-3.635-.7-4.947-1.94C.74 16.819.003 15.137 0 13.383V4.828a4.536 4.536 0 0 1 .365-1.843 4.75 4.75 0 0 1 1.087-1.567A5.065 5.065 0 0 1 3.096.368a5.293 5.293 0 0 1 3.888 0c.616.244 1.174.6 1.643 1.05.469.45.839.982 1.088 1.567.25.586.373 1.212.364 1.843v8.555a2.837 2.837 0 0 1-.92 2.027A3.174 3.174 0 0 1 7 16.245c-.807 0-1.582-.3-2.158-.835a2.837 2.837 0 0 1-.92-2.027v-6.22a1.119 1.119 0 1 1 2.237 0v6.22a.777.777 0 0 0 .256.547.868.868 0 0 0 .585.224c.219 0 .429-.08.586-.224a.777.777 0 0 0 .256-.546V4.828A2.522 2.522 0 0 0 7.643 3.8a2.64 2.64 0 0 0-.604-.876 2.816 2.816 0 0 0-.915-.587 2.943 2.943 0 0 0-2.168 0 2.816 2.816 0 0 0-.916.587 2.64 2.64 0 0 0-.604.876 2.522 2.522 0 0 0-.198 1.028v8.555c0 1.194.501 2.339 1.394 3.183A4.906 4.906 0 0 0 7 17.885a4.906 4.906 0 0 0 3.367-1.319 4.382 4.382 0 0 0 1.395-3.183v-6.22a1.119 1.119 0 0 1 2.237 0v6.22c-.002 1.754-.74 3.436-2.052 4.677C10.635 19.3 8.856 19.998 7 20z" fill="currentColor"></path>
                </svg>
            </label>
            {#if isDemoMode}
                <button id="demo-button" type="button" class="btn btn-dark rounded-circle" on:click={sendMessage} disabled={hasRanOnce}>
                    <i class="fa fa-paper-plane"></i>
                </button>
            {:else if isLoading}
                <button type="button" class="btn btn-dark rounded-circle" on:click={handleStop}>
                    <i class="fa fa-stop"></i>
                </button>
            {:else}
                <button type="button" class="btn btn-dark rounded-circle" disabled={!clinicalNotes.trim() && files.length === 0} on:click={sendMessage}>
                    <i class="fa fa-paper-plane"></i>
                </button>
            {/if}
        </div>
    </div>
</div>
